export const enum CurrentPageListNames {
    PARTICIPANT = 'participantCurrentPage',
    PROGRAM = 'programCurrentPage',
    SERVICE = 'serviceCurrentPage',
    PROGRAM_TEMPLATE = 'programTemplateCurrentPage',
}
